<div id="offlineDonation" #offlineDonation style="margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="px-5 pt-4">
        <div class="row pt-5 d-flex justify-content-center">
            <div class="col" style="margin-left: 6.9rem; margin-bottom: 2rem;">
                <div> Add donation support the one by one or bulk recording of offline donations. Supported campaign types: </div>
                <div>
                    <ul>
                        <li>Donation</li>
                        <li>Long Pledge</li>
                        <li>Peer to Peer</li>
                        <li>In Kind Donation</li>
                    </ul>
                </div>
                <div><b>Tickets:</b> Please use the Add Tickets button from Manage/Tickets and Guests.</div>
                <div>For other campaign types, first add it to the donor's cart from Reports/All Pending and check out.</div>
            </div>
        </div>
        <div class="row pt-5 d-flex justify-content-center">
            <div class="col-md-2 pl-5 pl-md-0 pb-5">
                <div class="steps-form-3">
                    <div class="steps-row-3 setup-panel-3 d-flex justify-content-between">
                        <div class="steps-step-3">
                            <a id="step1a" href="#stepDonorSearch" type="button" class="btn btn-info btn-circle-3 waves-effect ml-0" data-toggle="tooltip" data-placement="top" title="Donor Search"><i class="fa fa-search" aria-hidden="true"></i></a>
                        </div>
                        <div class="steps-step-3">
                            <a id="step2a" href="#stepDonorSelected" type="button" class="btn btn-pink btn-circle-3 waves-effect p-3" data-toggle="tooltip" data-placement="top" title="Donor Information"><i class="fa fa-user" aria-hidden="true"></i></a>
                        </div>
                        <div class="steps-step-3">
                            <a id="step3a" href="#stepAddDonation" type="button" class="btn btn-pink btn-circle-3 waves-effect" data-toggle="tooltip" data-placement="top" title="Add Donation"><i class="fa fa-columns" aria-hidden="true"></i></a>
                        </div>
                        <div class="steps-step-3 no-height">
                            <a id="step4a" href="#stepDone" type="button" class="btn btn-pink btn-circle-3 waves-effect p-3" data-toggle="tooltip" data-placement="top" title="Done"><i class="fa fa-check" aria-hidden="true"></i></a>
                        </div>
                    </div>
                </div>
    
            </div>
            <div class="col-md-7 custom-material-form " [formGroup]="form">
                <div class="row setup-content-3" id="stepDonorSearch">
                    <div class="col-md-12">
                        <h3 class="font-weight-bold pl-0 my-4"><strong>Search Donor</strong></h3>
                        
                        <mdb-form-control class="form-fill">
                            <input
                                mdbInput
                                formControlName="email"
                                [mdbAutocomplete]="autocompleteEmail"
                                (keydown.enter)="passOption($event)"
                                maxlength="128"
                                type="text"
                                id="donorSearchEmail"
                                class="form-control form-control--paybee"
                            />
                            <label mdbLabel class="form-label form-label--paybee">Email</label>
                            @if (form.controls.email.invalid && form.controls.email.touched) {
                                <span class="form-fill-error">Invalid Email</span>
                            }
                        </mdb-form-control>
                        <mdb-autocomplete #autocompleteEmail="mdbAutocomplete">
                            @for(option of searchResult; track option.data.id) {
                                <mdb-option [value]="option.searchString" (click)="passOption(option.searchString)">
                                    {{ option.searchString }}
                                </mdb-option>
                            }
                        </mdb-autocomplete>

                        <mdb-form-control class="form-fill">
                            <input
                                mdbInput
                                formControlName="name"
                                [mdbAutocomplete]="autocompleteName"
                                (keydown.enter)="passOption($event)"
                                maxlength="128"
                                type="text"
                                id="donorSearchName"
                                class="form-control form-control--paybee"
                            />
                            <label mdbLabel class="form-label form-label--paybee">Name</label>
                            @if (form.controls.name.invalid && form.controls.name.touched) {
                                <span class="form-fill-error">Invalid Name</span>
                            }
                        </mdb-form-control>
                        <mdb-autocomplete #autocompleteName="mdbAutocomplete">
                            @for(option of searchResult; track option.data.id) {
                                <mdb-option [value]="option.searchString" (click)="passOption(option.searchString)">
                                    {{ option.searchString }}
                                </mdb-option>
                            }
                        </mdb-autocomplete>

                        <h4 style="margin-top: 1rem; margin-bottom: 1rem">Or</h4>
                        <div class="row" style="margin-top: 1rem">
                            <div class="col">
                                <a id="createNewDonor" class="btn btn-mdb-color btn-rounded">Create New User</a>
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- Second Step -->
                <div class="row setup-content-3 custom-material-form" id="stepDonorSelected">
                    <div class="col-md-12">
                        <h3 class="font-weight-bold pl-0 my-4"><strong>Selected Donor</strong></h3>
                        <div id="selectedUserDiv" style="display: none">
                            <div class="card-body">
                                <h4 class="card-title" id="offlineDonorName"></h4>
                                <p id="offlineDonorEmail"></p>
                                <p id="offlineDonorAddress"></p>
                                <hr>
                            </div>
                        </div>
                        <div id="createUserDiv" style="display: none">
                            <form onsubmit="return false">
                                <div class="md-form" style="margin-bottom: 2rem;">
                                    <input
                                            type="text"
                                            id="offlineName"
                                            autocomplete='name'
                                            required
                                            class="form-control validate">
                                    <label
                                            id="offlineNameLabel"
                                            class="inputLabel"
                                            for="offlineName"
                                            data-error="Invalid"
                                            data-success="">Donor Name</label>
                                </div>
    
                                <div class="md-form" style="margin-bottom: 2rem;">
                                    <input
                                            type="email"
                                            id="offlineEmail"
                                            autocomplete='email'
                                            required
                                            class="form-control validate">
                                    <label
                                            id="offlineEmailLabel"
                                            class="inputLabel"
                                            for="offlineEmail"
                                            data-error="Invalid"
                                            data-success="">Donor Email</label>
                                </div>
                                <h5>Or</h5>
                                <div id="streetAddressDiv">
                                    <h6 class="text-left sectionHeading" style="color: black">Donor Street Address</h6>
                                    <div class="md-form">
                                        <input autocomplete="off" class="form-control" type="text" placeholder="Search for address" id="offlineStreetAddress" onfocus="this.setAttribute('autocomplete','chrome-off')">
                                    </div>
                                    <div class="row">
                                        <div class="col-md-8 col-md-10">
                                            <div class="md-form">
                                                <input class="form-control" type="text" id="offlineStreetAddressUnit">
                                                <label id="streetAddressUnitLabel"
                                                       class="inputLabel"
                                                       for="offlineStreetAddressUnit"
                                                       data-error="Invalid"
                                                       data-success="">Unit/Apartment# (optional)</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <small class="red-text" id="addressError"></small>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <a id="selectOfflineUser" style="margin-top: 2rem" class="btn btn-mdb-color btn-rounded">Select User</a>
                    </div>
                </div>
    
                <!-- Third Step -->
                <div class="row setup-content-3" id="stepAddDonation">
                    <div class="col-md-12">
                        <h3 class="font-weight-bold pl-0 my-4"><strong>Add Donation</strong></h3>
                        <div id="addOfflineDonationDiv" class="custom-material-form angular-custom-material-form" style="display:none">
                            <div class="row">
                                <div class="col text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Campaign</div>
                                    <fieldset id="offlineCampaignFS" class="form-group noMargin" style="margin-bottom: 1rem;">
                                    </fieldset>
                                    <small class="red-text" id="offlineCampaignError"></small>
                                </div>
                            </div>
                            <div id="offlineSelectOption" class="row" style="display: none">
                                <div class="col text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Select Option</div>
                                    <fieldset id="offlineOptionFS" class="form-group noMargin caret-left" style="margin-bottom: 1rem;">
                                    </fieldset>
                                </div>
                            </div>
                            <div class="row" id="offlineAmountRow">
                                <div class="col">
                                    <div class="md-form">
                                        <input
                                            min="1"
                                            step="0.01"
                                            type="number"
                                            id="amountOffline"
                                            class="form-control validate">
                                        <label
                                            class="inputLabel"
                                            data-error="Invalid Amount"
                                            data-success=""
                                            for="amountOffline">Amount</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="md-form">
                                        <input placeholder="Donation date" type="text" id="offlineDonationDate" class="form-control datepicker">
                                        <label id="offlineDonationDateLabel" for="offlineDonationDate">Donation Date</label>
                                        <i _ngcontent-qpx-c375="" onclick="document.getElementById('offlineDonationDate').focus()" class="far fa-calendar-alt calendar-icon--paybee active" style="cursor: pointer;"></i>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row">
                                <div class="col text-left">
                                    <div class="text-left" style="color: #757575; font-size: 0.8rem;">Donation Type</div>
                                    <fieldset class="form-group noMargin caret-left" id="selectDonationType" style="margin-bottom: 2rem;">
                                        <select id="donationType" class="mdb-select noMargin validate">
                                            <option value="0" selected>Donation</option>
                                            <option value="1">Corp Matching</option>
                                            <option value="2">Charitable Trust Donation</option>
                                        </select>
                                    </fieldset>
                                </div>
                            </div>
    
                            <div class="row" id="offlineMatchingCompanyRow">
                                <div class="col">
                                    <div class="md-form">
                                        <input type="text" length="256" maxlength="256" id="offlineMatchingCompany" class="form-control">
                                        <label id="offlineMatchingCompanyLabel" for="offlineMatchingCompany" class="form-label">Matching Company Name (optional)</label>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row" id="trustDonationNameRow">
                                <div class="col">
                                    <div class="md-form">
                                        <input type="text" length="256" maxlength="256" id="trustDonationName" class="form-control validate">
                                        <label id="trustDonationNameLabel" data-error="invalid" data-success="" for="trustDonationName" class="inputLabel">Trust Name (optional)</label>
                                    </div>
                                </div>
                            </div>
    
    
                            <div class="row">
                                <div class="col text-left">
                                    <fieldset class="form-group noMargin caret-left" id="selectDonationBy" style="margin-bottom: 2rem;">
                                        <div class="text-left" style="color: #757575; font-size: 0.8rem;">Donation By</div>
                                        <select id="donationBy" class="mdb-select noMargin validate">
                                            <option value="0" selected>Check</option>
                                            <option value="1">Cash</option>
                                            <option value="3">InKind</option>
                                            <option value="4">Stock</option>
                                            <option value="2">Other</option>
                                        </select>
                                    </fieldset>
                                </div>
                            </div>
                            <div id="stockInfoRow">
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                        <input type="text" length="256" maxlength="256" id="stockSymbol" class="form-control validate">
                                        <label id="stockSymbolLabel" data-error="invalid" data-success="" for="stockSymbol" class="inputLabel">Stock Symbol</label>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="md-form">
                                        <input type="number" id="stockQuantity" class="form-control validate">
                                        <label id="stockQuantityLabel" data-error="invalid" data-success="" for="stockQuantity" class="inputLabel">Stock Quantity</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="md-form">
                                            <input type="text" length="256" maxlength="256" id="stockBrokerage" class="form-control">
                                            <label for="stockBrokerage" class="form-label">Brokerage Name(optional)</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="row" id="inKindDescriptionRow">
                                <div class="col">
                                    <div class="md-form">
                                        <input type="text" length="256" maxlength="256" id="inKindDescription" class="form-control validate">
                                        <label id="inKindDescriptionLabel" data-error="invalid" data-success="" for="inKindDescription" class="inputLabel">Item description</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="md-form">
                                        <textarea type="text" length="256" maxlength="256" id="memoOffline" class="form-control" style="background-color: rgba(0,0,0,.04)!important;"></textarea>
                                        <label for="memoOffline" class="form-label">Memo (optional)</label>
                                    </div>
                                </div>
                            </div>
                            <a id="addOfflineDonation" style="margin-top: 2rem" class="btn btn-mdb-color btn-rounded">Add Donation</a>
                        </div>
                    </div>
                </div>
    
                <div class="row setup-content-3" id="stepDone">
                    <div class="col-md-12">
                        <h3 class="font-weight-bold pl-0 my-4"><strong>Done</strong></h3>
                        <h6 class="text-center my-6">Donation Recorded</h6>
                        <a id="addOfflineAnother" class="btn btn-mdb-color btn-rounded">Add Another</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>